<div class="d-flex align-items-center justify-content-between item-room">
    <div class="d-flex align-items-start flex-column gap-2">
        <span class="block-name-game">{{ data.name }}</span>
        @if(data.stage_slug === 'waiting'){
          @if(data.password_required){
            @if(isOpenRoom(data)){
              <div class="d-flex align-items-center item-room-code">
                  <mat-form-field appearance="outline" class="input-code-room w-100">
                      <button matTextPrefix matIconButton aria-label="Clear">
                          <mat-icon>lock</mat-icon>
                      </button>
                      <input matInput type="text" 
                      placeholder="{{ 'list.txtEnterPassword' | translate }}"
                      maxlength="4" 
                      [formControl]="pass"
                      (blur)="updateErrorMessage()" required>
                  </mat-form-field>
              </div>
            }@else{
              <span class="room-condition close">
                  <span class="material-symbols-outlined">lock</span>
                  <span>{{ 'list.txtPrivateRoom' | translate }}</span>
              </span>
            }
          }@else{
            <span class="room-condition open">{{ 'list.txtOpenRoom' | translate }}</span>
          }
          
        }
        @if(data.stage_slug === 'inprogress'){
          <span class="room-condition close">
              <span class="material-symbols-outlined">lock</span>
              <span>{{ 'list.txtGameStarted' | translate }}</span>
          </span>
        }
        
    </div>
    <div class="d-flex align-items-end flex-column justify-content-end gap-2 mobile-style">
        <div class="d-flex align-items-center justify-content-end sand-timer">
          @if(data.stage_slug === 'waiting'){
            @if(isOpenRoom(data)){
              <span class="material-symbols-outlined">hourglass_bottom</span>
              <span>{{ 'list.txtWaitPlayer' | translate }}</span>
            }@else{
              <span class="material-symbols-outlined">done_all</span>
              <span>{{ 'list.txtRoomFull' | translate }}</span>
            }
            
          }
          @if(data.stage_slug === 'inprogress'){
            <span class="material-symbols-outlined">gamepad</span>
            <span>{{ 'list.txtGameInProgress' | translate }}</span>
          }
        </div>
        @if(data.stage_slug === 'waiting'){
          <button type="button" [disabled]="switch(data)" (click)="goToGame(data)" class="d-flex align-items-center justify-content-center item-room-join">
            @if(isNotClick){
              <span>{{ 'buttons.txtJoin' | translate }}</span>
              <span class="material-symbols-outlined">arrow_right_alt</span>
            }@else{
              <span>{{ 'buttons.txtJoining' | translate }}</span>
              <span class="material-symbols-outlined">progress_activity</span>
            }
          </button>
        }
        @if(data.stage_slug === 'inprogress'){
          <button type="button" disabled class="d-flex align-items-center justify-content-center item-room-join">
            <span>{{ 'buttons.txtJoin' | translate }}</span>
            <span class="material-symbols-outlined">arrow_right_alt</span>
          </button>
        }
    </div>
    @if( data.password_required && isOpenRoom(data) ){
      <div class="align-items-center justify-content-start is-mobile-show">
          <mat-form-field appearance="outline" class="input-code-room w-100">
              <button matTextPrefix matIconButton aria-label="Clear">
                  <mat-icon>lock</mat-icon>
              </button>
              <input matInput type="text" 
              placeholder="{{ 'newGame.txtCode' | translate }}" 
              [formControl]="pass"
              (blur)="updateErrorMessage()" required>
          </mat-form-field>
      </div>
    }
</div>
<!-- <mat-card appearance="outlined">
  <div class="d-flex justify-content-between gap-2 align-items-center" style="padding: 0 8px;">
    <mat-card-header>
      <mat-card-title style="--mat-card-title-text-size: 0.675rem; color: #949797;">{{ 'list.txtRoom' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ data.name }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <app-tmp-status [_status]="data.stage_slug"></app-tmp-status>
    </mat-card-content>
  </div>
  <mat-card-actions align="end">
    @if(data.password_required){
      <div class="d-flex justify-content-between gap-2 align-items-center" style="width: 100%;">
        <mat-form-field style="width: 300px;">
        <input
            matInput
            placeholder="{{ 'newGame.txtCode' | translate }}"
            [formControl]="pass"
            (blur)="updateErrorMessage()"
            required
          />
          <mat-hint style="color: red;" >{{'error.'+errorMessage() | translate}}</mat-hint>
        </mat-form-field>
        <button class="room-login" [disabled]="switch(data)" (click)="goToGame(data)">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M480-120v-80h280v-560H480v-80h280q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H480Zm-80-160-55-58 102-102H120v-80h327L345-622l55-58 200 200-200 200Z"/></svg>
          <span>{{ 'buttons.txtSignIn' | translate }}</span>
        </button>
      </div>
    } @else{
      <button class="room-login" [disabled]="switch(data)" (click)="goToGame(data)">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M480-120v-80h280v-560H480v-80h280q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H480Zm-80-160-55-58 102-102H120v-80h327L345-622l55-58 200 200-200 200Z"/></svg>
        <span>{{ 'buttons.txtSignIn' | translate }}</span>
      </button>
    }
    
  </mat-card-actions>
</mat-card> -->
